import { render, staticRenderFns } from "./OtherSettings.vue?vue&type=template&id=14d4f06a&scoped=true"
import script from "./OtherSettings.vue?vue&type=script&lang=js"
export * from "./OtherSettings.vue?vue&type=script&lang=js"
import style0 from "./OtherSettings.vue?vue&type=style&index=0&id=14d4f06a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d4f06a",
  null
  
)

export default component.exports